import { connect } from 'react-redux';
import { Creators } from '../../../services/redux/document/actions';
import { Creators as UserCreators } from '../../../services/redux/user/actions';
import UploadDocuments from './components';
import _ from 'lodash';

const mapStateToProps = state => {
  const { user, isloading, error, error_message, requestId } = state.user;
  const { costs } = state.costs;
  return {
    user,
    isloading,
    error,
    request_id: requestId,
    error_message,
    object: state.object.object,
    line_id: state.object.lineId,
    object_type: state.object.selectedObjectType,
    object_name: state.object.selectedObjectName,
    total_cost: _.get(state.costs, 'costs.cost'),
    documents: costs && costs.documents,
    isUploading: state.document.isloading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    uploadDocument: (data, requestId) => {
      dispatch(Creators.uploadDocument(data, requestId));
    },
    saveUser: (data) => {
      dispatch(UserCreators.saveUser(data));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadDocuments);

